
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import UploadImg from '@/components/upload-img.vue';
	import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    memberAuthInfoByPhone
  } from "@/api/agent_user"
  import {
    orderImportmemberInfo,
    orderImportimport,
    orderImportgetImportDealResult,
    orderImportcancelOrder,
    orderImportrecordInit,
    orderImportrecordlist,
    mallgetQrCode
  } from "@/api/order"
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      UploadImg,
			'slz-dialog': Dialog,
			'slz-message': Message,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private radioType = 1
    private phone = ''
    private member:any = {}
    private isSearch = false
    private step2 = false
    private filepath = ''
    private filename = ''
    private fileList = []
    private importShow = false
    private importloading = false
    private schedule = 0
    private result:any = {}
    private tipShow = false
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1;
		private pageSize = 10;
		private total = 0;
    private waitCount = 0
    private ImportNo = ''
    private imgloading = false

    private mounted () {
      this.initTime()
      this.recordInit()
    }



    private initTime(){
      let year = new Date().getFullYear()
      this.filterTime = [year+'-01-01',getSearchDate(2)[0]].join('/')
    }
    private showPay(row){
      this.ImportNo = row.ImportNo
      this.schedule = 2
      this.getresult()
      this.importShow = true
    }
    private downResult(row){
      this.ImportNo = row.ImportNo
      this.exportResult()
    }
    private changeRadio(e){
      this.recordInit()
      if(e==2){
        this.changePage(1)
      }
    }
    private async recordInit(){
      try{
        let res = await orderImportrecordInit({})
        if(res.IsSuccess){
          this.waitCount = res.Result.WaitPayCount
        }
      }finally{
        //
      }
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await orderImportrecordlist(data)
        if(res.IsSuccess){
          this.total = res.Result.Total
          this.tablelist = res.Result.Results
        }
      }finally{
        this.tableloading = false
      }
    }
    private clearSearch(){
      this.initTime()
      this.query()
    }
    private query(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async cancelOrder(){
      try{
        let res:any = await orderImportcancelOrder({
          ImportNo:this.ImportNo
        })
        if(res.IsSuccess){
          this.$message.success('已取消本次导入的订单')
          this.tipShow = false
          this.importShow = false
          this.recordInit()
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private exportResult(){
      let url = location.origin + '/pc/orderImport/downloadDetail?ImportNo='+this.ImportNo
      window.open(url)
    }
    private async confirmImport(){
      if(!this.filepath){
        this.$message.error('请选择文件上传')
        return
      }
      this.schedule = 0
      this.importShow = true
      try{
        let res:any = await orderImportimport({
          Phone:this.phone,
          ExcelFilePath:this.filepath,
          ExcelFileName:this.filename
        })
        if(res.IsSuccess){
          this.ImportNo = res.Result.ImportNo
          this.getresult()
        }
      }catch(e){
        this.ImportNo = ''
        this.importShow = false
      }
    }
    private async getresult(){
      try{
        let res:any = await orderImportgetImportDealResult({
          ImportNo:this.ImportNo
        })
        if(res.IsSuccess){
          // console.log(res.Result)
          if(res.Result.OrderImportState==0){
            setTimeout(() => {
              this.getresult()
            }, 1000);
          }else if(res.Result.OrderImportState==1){//成功
            this.schedule = 2
            this.result = {
              ...res.Result,
              url:''
            }
            this.getUrl()
          }else{//失败
            this.schedule = 1
            this.result = res.Result
          }
        }
      }finally{
        //
      }
    }
    private async getUrl(){
      try{
        this.imgloading = true
        let res = await mallgetQrCode({
          Page:'pageA/pages/payOrder/payOrder',
          Scene:'orderNo='+this.ImportNo
        })
        if(res.IsSuccess){
          this.result.url = res.Result
        }
      }finally{
        this.imgloading = false
      }
    }
    private uploadSuc(file,name){
      // console.log(file,name)
      this.filepath = file[0]
      this.filename = name
    }
    private async doSearch(){
      if(!this.phone){
        this.$message.error('请输入要查询的手机号')
        return
      }
      try{
        let res = await orderImportmemberInfo({
          Phone:this.phone
        })
        if(res.IsSuccess){
          if(res.Result.Name){
            this.member = res.Result
          }
        }
      }catch(e){
        this.member = {}
        this.step2 = false
      }finally{
        this.isSearch = true
      }
    }
  }
